<svelte:options customElement="hb-sidenav-link" />

<script lang="ts">
  import type { INavLink } from "./types/webcomponent.type";

  /**
   * Svelte Sidenav Link WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import type { Component } from "./types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  function pageChange(page: string) {
    dispatch("pageChange", {
      page,
    });
  }

  let {
    id = "",
    // style,
    navlink,
    navpage,
    selected,
  }: Component = $props();

  let open = $state(false);

  $effect(() => {
    if (typeof navlink === "string") {
      try {
        navlink = JSON.parse(navlink as unknown as string);
        open = navlink.open === true ? true : false;
      } catch (err) {}
    }
    if ((selected as unknown as string) === "") {
      selected = true;
    } else if (
      typeof selected === "string" &&
      (selected === "yes" || selected === "true")
    ) {
      selected = true;
    } else if (selected !== true) {
      selected = false;
    }
    console.log(navlink, "navlink");
  });

  function openKey() {
    open = open === true ? false : true;
    console.log(open, "open");
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<span>
  {#if navlink}
    <li part="li" class="sidenav-item">
      {#if navlink.subLinks?.length}
        <button
          type="button"
          onclick={() => {
            openKey();
          }}
          class="button is-ghost is-fullwidth has-text-left sidenav-row-btn is-flex is-align-items-center is-gap-2"
        >
          <i class="bi bi-{navlink.icon} sidenav-icon"></i>
          <span class="sidenav-row__label">{navlink.label}</span>
          <span class="sidenav-row__trail">
            {#if open || (navlink.subLinks && navlink.subLinks.find((f) => f.key === navpage))}
              <span class="has-text-grey" aria-hidden="true">▼</span>
            {:else}
              <span class="has-text-grey" aria-hidden="true">►</span>
            {/if}
          </span>
        </button>
        {#if open || (navlink.subLinks && navlink.subLinks.find((f) => f.key === navpage))}
          <div class="pl-4">
            {#each navlink.subLinks as navLinkSub (navLinkSub.key)}
              {#if navLinkSub.key === navpage || selected}
                <button
                  type="button"
                  class="button is-link is-light is-fullwidth has-text-left sidenav-row-btn is-flex is-align-items-center is-gap-2"
                  aria-current="page"
                >
                  <i class="bi bi-{navLinkSub.icon} sidenav-icon"></i>
                  <span class="sidenav-row__label">{navLinkSub.label}</span>
                  <span class="sidenav-row__trail">
                    {#if navLinkSub.badge}
                      <span
                        class="tag sidenav-row__badge {navLinkSub.badge.class ||
                          'is-rounded'} {navLinkSub.badge.classcolor ||
                          'is-light'}">{navLinkSub.badge.text}</span
                      >
                    {/if}
                  </span>
                </button>
              {:else}
                <button
                  type="button"
                  onclick={() => {
                    pageChange(navLinkSub.key);
                  }}
                  class="button is-ghost is-fullwidth has-text-left sidenav-row-btn is-flex is-align-items-center is-gap-2"
                >
                  <i class="bi bi-{navLinkSub.icon} sidenav-icon"></i>
                  <span class="sidenav-row__label">{navLinkSub.label}</span>
                  <span class="sidenav-row__trail">
                    {#if navLinkSub.badge}
                      <span
                        class="tag sidenav-row__badge {navLinkSub.badge.class ||
                          'is-rounded'} {navLinkSub.badge.classcolor ||
                          'is-light'}">{navLinkSub.badge.text}</span
                      >
                    {/if}
                  </span>
                </button>
              {/if}
            {/each}
          </div>
        {/if}
      {:else if navlink.key === navpage || selected}
        <button
          type="button"
          class="button is-link is-light is-fullwidth has-text-left sidenav-row-btn is-flex is-align-items-center is-gap-2"
          aria-current="page"
        >
          <i class="bi bi-{navlink.icon} sidenav-icon"></i>
          <span class="sidenav-row__label">{navlink.label}</span>
          <span class="sidenav-row__trail">
            {#if navlink.badge}
              <span
                class="tag sidenav-row__badge {navlink.badge.class || 'is-rounded'} {navlink
                  .badge.classcolor || 'is-light'}">{navlink.badge.text}</span
              >
            {/if}
          </span>
        </button>
      {:else}
        <button
          type="button"
          onclick={() => {
            pageChange(navlink.key);
          }}
          class="button is-ghost is-fullwidth has-text-left sidenav-row-btn is-flex is-align-items-center is-gap-2"
        >
          <i class="bi bi-{navlink.icon} sidenav-icon"></i>
          <span class="sidenav-row__label">{navlink.label}</span>
          <span class="sidenav-row__trail">
            {#if navlink.badge}
              <span
                class="tag sidenav-row__badge {navlink.badge.class || 'is-rounded'} {navlink
                  .badge.classcolor || 'is-light'}">{navlink.badge.text}</span
              >
            {/if}
          </span>
        </button>
      {/if}
    </li>
  {/if}
</span>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";

  i.sidenav-icon {
    min-width: 1rem;
    display: inline-block;
  }
</style>
